import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { polymorphicFactory, useProps } from "@coveord/plasma-mantine";
import { ExternalSize16Px } from "@coveord/plasma-react-icons";
import { clsx } from "clsx";
import { Anchor } from "../anchor/Anchor.js";
import classes from "./ExternalAnchor.module.css";
var defaultProps = {
    showIcon: true
};
export var ExternalAnchor = polymorphicFactory(function(props, ref) {
    var _ref = useProps("ExternalAnchor", defaultProps, props), unstyled = _ref.unstyled, children = _ref.children, showIcon = _ref.showIcon, others = _object_without_properties(_ref, [
        "unstyled",
        "children",
        "showIcon"
    ]);
    return /*#__PURE__*/ _jsxs(Anchor, _object_spread_props(_object_spread({
        unstyled: unstyled,
        ref: ref
    }, others), {
        children: [
            children,
            showIcon ? /*#__PURE__*/ _jsx(ExternalSize16Px, {
                className: clsx(_define_property({}, classes.icon, !unstyled)),
                height: 16
            }) : null
        ]
    }));
});

//# sourceMappingURL=ExternalAnchor.js.map